<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">Home</h1>

      <section v-if="loading" class="loading-section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style scoped>
</style>
